export enum FormScene {
  Starter = 'Starter',
  AboutUs = 'AboutUs',
  Agreement = 'Agreement',
  Detail = 'Detail',
  Questions = 'Questions',
  Presentation = 'Presentation',
  PaymentData = 'PaymentData',
  Summary = 'Summary',
  UploadIdentityCard = 'UploadIdentityCard',
  TransmitReport = 'TransmitReport',
}
